import { useEffect, useState } from "react";
import useApi from "../../../../../hooks/use-api";
import { useForm } from "react-hook-form";
import styles from '../../../../../styles/transitionplan.module.css';
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave } from "@fortawesome/free-solid-svg-icons";

const GoalsAddEdit = ({ApplicationID,NeedID,GoalID,ReturnFunction,RefreshFunction}) => {
    const [isLoading,SetisLoading] = useState(true);
    const [feedback, setFeedback] = useState(null);
    
    const initialValues = {
        goal: '',
        comment: ''
    }

    const {control,register,handleSubmit,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const {getRequest,postRequest,putRequest} = useApi();

    const _onSubmit = async(items) => {
        setFeedback(null);

        if(GoalID){
            const [data,status] = await putRequest('UpdateGoal',{...items,applicationid : ApplicationID,needid: NeedID,goalid: GoalID,title: items.goal,comments: items.comment});

            if(status === 200){
                setFeedback({ type: "success", message: "The Goal was successfully updated." });
                const extractedGoalData = {
                    goal: data.goal,
                    comment: data.comment
                }
    
                reset(extractedGoalData);
        
                RefreshFunction({ preserveEditorViewport: true });
                
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when updating the Goal." });
            }
        }
        else{
            const [data,status] = await postRequest('AddGoal',{...items,applicationid: ApplicationID,needid: NeedID,title: items.goal,comments: items.comment});

            if(status === 201){
                setFeedback({ type: "success", message: "The Goal was successfully added." });
        
                RefreshFunction({ preserveEditorViewport: true });
                reset(initialValues);
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when adding the Goal." });
            }
        }
    }

    const get = async() => {
        const [data,status] = await getRequest('Goal',{ApplicationID: ApplicationID,NeedID: NeedID,GoalID: GoalID,timestamp: new Date()});

        if (status === 200){
            const extractedGoalData = {
                goal: data.goal,
                comment: data.comment
            }

            reset(extractedGoalData);
        }
    }

    useEffect(() => {
        if(GoalID){
            get();
        }
        else{

        }
        SetisLoading(false);
    },[GoalID])

    if(isLoading){
        return(
            <div className={styles.statusMessage} role="status" aria-live="polite">Loading goal form...</div>
        )
    }

    return(
        <form onSubmit={handleSubmit(_onSubmit)}>
            <div className={`clientCard ${styles.editorEmbeddedCard}`}>
                <div className={`${styles.needBody} ${styles.editorEmbeddedBody}`}>
                        <div>
                            <label htmlFor="goaltitle">Goal</label>
                            <input type="text" id="goaltitle" {...register('goal')} style={{width: '100%'}}/>
                        </div>
                        <div>
                            <label htmlFor="goalcomment">Comments</label>
                            <textarea id="goalcomment" rows={4} style={{width: '100%'}} {...register('comment')} />
                        </div>
                        {feedback && (
                            <div className={`${styles.inlineFeedback} ${feedback.type === "error" ? styles.inlineFeedbackError : styles.inlineFeedbackSuccess}`} role="status" aria-live="polite">
                                {feedback.message}
                            </div>
                        )}
                        <div className="d-flex justify-content-end">
                            <Button type="submit" variant={GoalID !== null ? 'primary' : 'success'} disabled={isLoading || !isDirty || isSubmitting}>
                                {
                                    isSubmitting
                                    ?
                                        <Spinner animation='border' size='sm' aria-hidden="true" />
                                    :
                                        GoalID
                                        ?
                                            <>
                                                <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                                Save
                                            </>
                                        :
                                            <>
                                                <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                                Add Goal
                                            </>
                                }
                            </Button>
                        </div>
                </div>
            </div>
        </form>
    )
}

export default GoalsAddEdit;
